import { render, staticRenderFns } from "./textEdit.vue?vue&type=template&id=33c3b43f&scoped=true"
import script from "./textEdit.vue?vue&type=script&lang=js"
export * from "./textEdit.vue?vue&type=script&lang=js"
import style0 from "./textEdit.vue?vue&type=style&index=0&id=33c3b43f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3b43f",
  null
  
)

export default component.exports